import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS } from '@modules/general-settings/submodules/table-columns-settings/constants';

import type { IHistoryChangesOfTableColumnsResponse } from '../types';
import {
  HISTORY_CHANGES_OF_TABLE_COLUMNS_API_URL,
  HISTORY_CHANGES_OF_TABLE_COLUMNS_QUERY,
} from '../constants';

export default function useHistoryChangesOfTableColumnsQuery(
  tableId: Ref<number>,
  isEnabled: Ref<boolean>,
): IContextQueryResult<IHistoryChangesOfTableColumnsResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IHistoryChangesOfTableColumnsResponse>({
    queryKey: [HISTORY_CHANGES_OF_TABLE_COLUMNS_QUERY, tableId],
    queryFn: ({ signal }) => fetchGet<IHistoryChangesOfTableColumnsResponse>(
      HISTORY_CHANGES_OF_TABLE_COLUMNS_API_URL,
      {
        signal,
        permission: ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS.SHOW_VERSIONS,
        queryParams: {
          table_id: tableId.value,
        },
      },
    ),
    enabled: computed(() => isEnabled.value && !!tableId.value),
  });
}
